import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'

const NextArrow = ({ currentSlide, slideCount, ...props }) => <FontAwesomeIcon {...props} icon={faChevronRight} />

const PrevArrow = ({ currentSlide, slideCount, ...props }) => <FontAwesomeIcon {...props} icon={faChevronLeft} />

const defaultSettings = {
  infinite: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  dots: true,
  autoplay: true,
  speed: 1500,
  autoplaySpeed: 5000
}

export { defaultSettings, PrevArrow, NextArrow }
